import BranchFundingSourceHolidayCreateComponent from './branch_funding_source_holiday.create.component';

let BranchFundingSourceHolidayCreateModule = angular.module('branchFundingSourceHolidayCreate', [])

.component('branchFundingSourceHolidayCreate', BranchFundingSourceHolidayCreateComponent)

.name;

export default BranchFundingSourceHolidayCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/create/index.js